import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Correction } from "../model/Correction.model";
import { Observable } from "rxjs";
import { URL_API } from "./url.api";

@Injectable({
    providedIn: 'root'
})
export class CorrectionsService {

    constructor(
        public http: HttpClient
    ){}

    findById(correctionId: number): Observable<Correction> {
        return this.http.get<Correction>(`${URL_API}/corrections/${correctionId}`);
    }

    save(correction: Correction): Observable<any> {
        return this.http.post<any>(`${URL_API}/corrections`, correction);
    }

    update(correction: Correction): Observable<any> {
        return this.http.put<any>(`${URL_API}/corrections/${correction.id}`, correction);
    }

    delete(correctionId: number): Observable<any> {
        return this.http.delete<any>(`${URL_API}/corrections/${correctionId}`);
    }

    findAll(): Observable<Array<any>> {
        return this.http.get<Array<Correction>>(`${URL_API}/corrections`);
    }
}